import { Injectable } from '@angular/core';
import { BaseEffects } from '../helpers/base.effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import baseReducer from '../helpers/base.reducer';
import { BaseState } from '../helpers/base.state';
import { UserService } from '../../services/user.service';
import { UserModel } from '../../models';
import { catchError, map, switchMap } from 'rxjs/operators';
import ResponseModel from '../../models/response.model';
import { of } from 'rxjs';
import { statesActions } from '../core.actions';
import { commonReducerValidationsGenerator } from "../helpers/common-reducer-validations-generator";
import { MediaTypes } from "../../../core/interfaces/media.interface";

// STATE OF MENUS
export class UserState extends BaseState<UserModel> {
  userDetails = new UserModel();
  constructor() {
    super();
    this.data = new UserModel();
  }
}

// EFFECTS OF MENUS
@Injectable()
export class UserEffects extends BaseEffects<UserModel> {
  constructor(private actions: Actions<any>, private userService: UserService) {
    super('user', actions, userService);
  }

  getUserDetails$ = createEffect(() =>
    this.actions.pipe(
      ofType(statesActions.user.userDetails.submitted),
      switchMap(({ data }) =>
        this.userService.getUserDetails(data).pipe(
          map((response: ResponseModel<UserModel[]> | any) => {
            let photos: any[] =  []
            if(response?.data?.profile?.photos?.length > 0) {
              Object.keys(response.data.profile.photos).map(function(k) {
                var obj = response.data.profile.photos[k];
                if(MediaTypes.PHOTO === obj.contentType) {
                  photos.push(obj)
                }
              });
              response.data.profile.photos = photos; 
            }
            
            return statesActions.user.userDetails.success({
              ...response,
              data: response.data.profile
            });
          }),
          catchError((errorData: { error: ResponseModel<null> }) =>
            of(statesActions.user.userDetails.failed(errorData.error))
          )
        )
      )
    )
  );
}
// REDUCER OF MENUS
export const userReducer = baseReducer<UserState>('user', new UserState(), [
  ...commonReducerValidationsGenerator('user', 'userDetails'),
]);
